<div class="dialog-content-wrapper">
    <div class="m-0 flex w-full items-center justify-between bg-[#039be5] text-white p-4 ">
        <span class="text-4xl">{{dialogTitle}}</span>
        <mat-icon class="hover:bg-blue-400 hover:rounded  text-white" (click)="matDialogRef.close()">close</mat-icon>
    </div>

    <div mat-dialog-content class="p-4 pb-0 m-0 overflow-hidden">
        <form [formGroup]="monthForm" class="w-full pt-2">
            <div class="flex flex-row gap-4">
                <mat-form-field dense appearance="outline" floatLabel="always" class="flex-[3_3_0%] min-w-0">
                    <mat-label>Mes</mat-label>
                    <mat-select formControlName="month">
                        <mat-option *ngFor="let rep of months" [value]="rep">
                            {{monthsStr[rep]}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field dense appearance="outline" floatLabel="always" class="flex-[2_2_0%] min-w-0">
                    <mat-label>Año</mat-label>
                    <input name="year" formControlName="year" matInput>
                </mat-form-field>
            </div>
        </form>
    </div>

    <div mat-dialog-actions class="accent m-0 p-4 pt-0 flex flex-row items-center justify-end">
        <button mat-button
                class="mr-2"
                (click)="matDialogRef.close()"
                matTooltip="Cancelar">
            Cancelar
        </button>

        <button mat-button
                class="accent font-semibold"
                (click)="matDialogRef.close(monthForm)"
                [disabled]="monthForm.invalid"
                aria-label="SAVE">
            Generar Reporte
        </button>
    </div>
</div>

